import React from "react";
import { connect, ConnectedProps } from "react-redux";
import GovernorateProfile from "./GovernorateProfile";

interface IProps {
  owner: boolean;
}

const mapStateToProps = (state: any) => ({
  id: state.governorate.id,
  name: state.governorate.name,
  race: state.governorate.race,
  alliance: state.governorate.alliance,
  membershipApplication: state.governorate.membershipApplication,
  land: state.governorate.land,
  landPosition: state.governorate.landPosition,
  power: state.governorate.power,
  powerPosition: state.governorate.powerPosition,
  ljpPoints: state.governorate.ljpPoints,
  rating: state.governorate.rating,
  war: state.governorate.war,
  lastAction: state.governorate.lastAction,
  note: state.governorate.note,
  player: state.governorate.player,
});

const connector = connect(mapStateToProps);

const OwnGovernorateProfile = ({
  id,
  name,
  race,
  alliance,
  membershipApplication,
  land,
  landPosition,
  power,
  powerPosition,
  ljpPoints,
  rating,
  war,
  lastAction,
  note,
  player,
}: IProps & ConnectedProps<typeof connector>) => {
  const governorate = {
    id,
    name,
    race,
    alliance,
    land,
    landPosition,
    power,
    powerPosition,
    ljp: ljpPoints,
    rating,
    lastAction,
    note
  }

  return (
    <GovernorateProfile
      governorate={governorate}
      membershipApplicationName={membershipApplication && membershipApplication.name}
      owner={true}
      player={player}
      war={!!war}
    />
  )
};

export default connector(OwnGovernorateProfile);
